export const MENU_ROUTES = {
  builder: {
    name: 'Builder',
    path: '/builder',
  },
  overview: {
    name: 'Overview',
    path: '/overview',
  },
  designSystem: {
    name: 'Design System',
    path: '/',
  },
};

export const LIBRARY_LINKS = {
  esri_lib_path: 'https://fs.fuselabcreative.com/public/Esri_Library.ppkx',
  excel_lib_path: 'https://fs.fuselabcreative.com/public/Excel_Library.xlsx',
  figma_lib_path: 'https://fs.fuselabcreative.com/public/Figma_Library.fig',
  pbi_lib_path: 'https://fs.fuselabcreative.com/public/PBI_Library.pbix',
  covid19_dashboard_path: 'https://fs.fuselabcreative.com/public/CDDT_Covid_POC_Rux_v2-9.pbix',
};

// The Logos page's Download Assets packages: the eight DHCS logo files in one format each.
export const LOGO_PACKAGE_LINKS = {
  svg: '/downloads/logos/DHCS-Logos-SVG.zip',
  png: '/downloads/logos/DHCS-Logos-PNG.zip',
  jpg: '/downloads/logos/DHCS-Logos-JPG.zip',
};

export const REFERENCE_LINKS = {
  dhcsVisualIdentityResources: 'https://cadhcs.sharepoint.com/',
  digitalGovUsabilityTesting: 'https://digital.gov/topics/usability',
  digitalGovPlainLanguageGuide: 'https://digital.gov/guides/plain-language',
  digitalGovAccessibilityForTeams: 'https://digital.gov/topics/accessibility',
  inclusiveDesignPrinciples: 'https://inclusivedesignprinciples.info/',
  section508Program: 'https://www.section508.gov',
  section508CoordinatorsGithub: 'https://github.com/Section508Coordinators',
  section508AccessibilityRequirementsTool: 'https://www.section508.gov/art/#/',
  section508UniversalDesign: 'https://www.section508.gov/develop/universal-design/',
  section508ProgramManagerListing: 'https://www.section508.gov/tools/program-manager-listing/',
  ictTestingBaseline: 'https://ictbaseline.access-board.gov/',
  ibmAccessibilityChecklist: 'https://www.ibm.com/support/pages/ibm-accessibility-checklist',
  eighteenFAccessibilityGuide: 'https://guides.18f.org/accessibility/',
  w3cPerspectiveVideos: 'https://www.w3.org/WAI/perspective-videos/',
  robDodsonAccessibilityFundamentals: 'https://www.youtube.com/watch?v=z8xUCzToff8',
  microsoftInclusiveDesign: 'https://inclusive.microsoft.design/',
  inclusiveComponents: 'https://inclusive-components.design/',
  humaneByDesign: 'https://humanebydesign.com/',
};
